var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H8C6.897 2 6 2.897 6 4V16C6 17.103 6.897 18 8 18H20C21.103 18 22 17.103 22 16V4C22 2.897 21.103 2 20 2ZM8 16V4H20L20.002 16H8Z",
    fill: "#C10037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H2V20C2 21.103 2.897 22 4 22H16V20H4V8Z",
    fill: "#C10037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L11 11L9 14H19L15 8L12 12Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryicon);
export default __webpack_public_path__ + "static/media/galleryicon.d6622bd1d1cfdacd1a01837a30387848.svg";
export { ForwardRef as ReactComponent };